import axios from 'axios';
import React from 'react';
import DistributeCounter from '../../components/DistributeCounter/DistributeCounter';
import HeaderPage from '../../components/PageHeader/PageHeader';
import StepCounter from '../../components/StepCounter/StepCounter';
import { retornarCookie } from '../../services/cookieservice';
import DistribuicaoFaixasElegibilidadePage from '../DistribuicaoFaixasElegibilidadePage/DistribuicaoFaixasElegibilidadePage';
import ListaElegibilidadesPage from '../ListaElegibilidadesPage/ListaElegibilidadesPage';
import SelecaoPlanoElegibilidadePage from '../SelecaoPlanoElegibilidadePage/SelecaoPlanoElegibilidadePage';
import './ElegibilidadePage.css';
import Loader from '../../components/Loader/Loader';

const { REACT_APP_API } = process.env;

export default class ElegibilidadePage extends React.Component {
  constructor(props) {
    super(props);

    this.controlaVisualizacao = this.controlaVisualizacao.bind(this);
    this.distribuirVidas = this.distribuirVidas.bind(this);
    this.finalizarSelecaoPlanoElegibilidade = this.finalizarSelecaoPlanoElegibilidade.bind(this);
    this.finalizarDistribuicaoFaixasElegibilidade = this.finalizarDistribuicaoFaixasElegibilidade.bind(this);
  }

  state = {
    oportunidade: undefined,
    vidasrestantes: undefined,
    visualizar: 'ListaElegibilidadesPage',
    elegibilidadePlanos: undefined,
    distribuicaoFaixa: undefined,
    exibeCarregamento: false,
  };

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const oportunidadeId = urlParams.get('OportunidadeID');

    this.carregarOportunidade(oportunidadeId);
    this.carregarVidasRestantes();
  }

  async carregarVidasRestantes() {
    const urlParams = new URLSearchParams(window.location.search);
    const IdAgenteVendas = retornarCookie("IdAgenteVenda");
    const oportunidadeId = urlParams.get('OportunidadeID');

    const params = {
      oportunidadeID: oportunidadeId,
      IdAgenteVendas,
    };

    axios
      .get(`${REACT_APP_API}elegibilidade/VidasRestantes`, { params })
      .then((res) => {
        const vidasrestantes = res.data;
        
        this.setState({ vidasrestantes });
      });
  }


  async carregarOportunidade(oportunidadeID) {

    this.setState({ exibeCarregamento: true })

    const IdAgenteVendas = retornarCookie('IdAgenteVenda');
    const CdAgenteVendas = retornarCookie('CdAgenteVendas');

    const params = {
      oportunidadeID,
      IdAgenteVendas,
      CdAgenteVendas,
      multiplasPropostas: false,
    };

    axios.get(`${REACT_APP_API}oportunidade/OportunidadePorId`, { params }).then((res) => {
      const oportunidade = { ...res.data };

      this.setState({ oportunidade });
      this.setState({ exibeCarregamento: false })
    });
  }

  async distribuirVidas() {
    this.controlaVisualizacao('SelecaoPlanoElegibilidadePage');
  }

  async finalizarSelecaoPlanoElegibilidade(elegibilidadePlanos) {
    this.setState({ elegibilidadePlanos });
    this.controlaVisualizacao('DistribuicaoFaixasElegibilidadePage');
  }

  async finalizarDistribuicaoFaixasElegibilidade(distribuicaoFaixa) {

    if (parseInt(distribuicaoFaixa.totalVidas) < parseInt(localStorage.getItem('VidasDistribuicao'))) {
      alert('Para continuar é necessário distribuir todas as vidas configuradas para essa elegibilidade.');
    } else {
      this.setState({ distribuicaoFaixa });
      this.inserirElegibilidade(distribuicaoFaixa);
    }

  }

  async controlaVisualizacao(visualizar) {
    this.setState({ visualizar });
  }

  async inserirElegibilidade(distribuicaoFaixa) {
    this.setState({ exibeCarregamento: true })

    const planos = this.montaPlanos();
    const faixasEtarias = this.montaFaixasEtarias(distribuicaoFaixa);

    // remover acentos da state.elegibilidadePlanos.nomeElegibilidade, mas, fazendo o replace de acentos por caracteres sem acento, e uppercase
    const nomeElegibilidadeSemAcentos = this.state.elegibilidadePlanos.nomeElegibilidade.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();

    const data = {
      OportunidadeID: this.state.oportunidade.OportunidadeID,
      Nome: nomeElegibilidadeSemAcentos,
      QtdeVidasTotal: distribuicaoFaixa.totalVidas,
      Planos: planos,
      FaixasEtariasVidas: faixasEtarias,
    };

    if (data.OportunidadeID && data.Nome && data.QtdeVidasTotal && data.Planos.length && data.FaixasEtariasVidas.length) {
      const IdAgenteVendas = retornarCookie('IdAgenteVenda');
      const Filial = retornarCookie('Filial');

      const params = {
        IdAgenteVendas,
        MEI: this.state.oportunidade.MEI,
        Filial,
        cep: this.state.oportunidade.CEP,
      };

      axios.post(`${REACT_APP_API}elegibilidade`, data, { params }).then((res) => {
        window.location.reload();
        this.setState({ exibeCarregamento: false })
      });
    }
  }

  montaPlanos() {
    const planosSelecionados = [
      ...this.state.elegibilidadePlanos.planosMedicina.filter((x) => x.Selecionado),
      ...this.state.elegibilidadePlanos.planosOdonto.filter((x) => x.Selecionado),
    ];

    return [
      ...planosSelecionados.map((x) => {
        return {
          Id: x.IDPlano,
          NomePlano: x.DescricaoPlano,
        };
      }),
    ];
  }

  montaFaixasEtarias(distribuicaoFaixa) {
    const faixas = distribuicaoFaixa.faixas.filter((x) => x.total_vidas > 0);

    return [
      ...faixas.map((x) => {
        return {
          Id: x.i9_faixaetariapadraoId,
          NomeFaixaEtaria: x.i9_name,
          QtdeVidasDistribuidsaFaixaEtaria: x.total_vidas,
        };
      }),
    ];
  }

  render() {

    const passoAtual = () => {
      const { oportunidade } = this.state;
      const nivelRaw = oportunidade?.NivelOportunidade ?? oportunidade?.nivelOportunidade;
      const qtdeVidasRaw = oportunidade?.QtdeVidas ?? oportunidade?.qtdeVidas;
      const nivel = Number(nivelRaw);
      const qtdeVidas = Number(qtdeVidasRaw);
      const isNivel2 =
        nivel === 2 ||
        (!Number.isNaN(qtdeVidas) && qtdeVidas >= 30 && qtdeVidas <= 99);
      const isFilial3 = retornarCookie('Filial') === '3';
      const reembolsoRaw =
        oportunidade?.ReembolsoDiferenciado ?? oportunidade?.reembolsoDiferenciado;
      const hasReembolso =
        reembolsoRaw === true || reembolsoRaw === 1 || reembolsoRaw === '1' || reembolsoRaw === 'true';

      if (!isNivel2) {
        return <StepCounter step="2" total="4" />;
      }

      if (isFilial3) {
        return <StepCounter step="3" total="5" />;
      }

      return <StepCounter step="3" total={hasReembolso ? "6" : "5"} />;
    }

    const { oportunidade, visualizar } = { ...this.state };

    return (
      <div className="fade-in">
        {this.state.exibeCarregamento && <Loader />}

        <div className="row container">
          <div className="col s9 m9 l9">
            <br />
            <b>
              <h5>Nova Oportunidade</h5>
            </b>
          </div>
          <div className="col s3 m3 l3">
            <br />
            {passoAtual()}
          </div>
        </div>
        <div className="row container">
          <HeaderPage
            Spotlight="Elegibilidade"
            Description='É necessário distribuir as vidas para a cotação dos planos. Confira as informações abaixo e clique no botão "Distribuir vidas" para continuar.'
          />
          {oportunidade && (
            <div className="col s3 m3 l3 offset-s5 offset-m5 offset-l5">
              <DistributeCounter holders={oportunidade.QtdeVidasTit} lives={oportunidade.QtdeVidas} remainingLives={this.state.vidasrestantes} />
            </div>
          )}
        </div>
        {oportunidade && (
          <>
            {visualizar === 'ListaElegibilidadesPage' && (
              <ListaElegibilidadesPage oportunidade={oportunidade} distribuirVidas={this.distribuirVidas} />
            )}
            {visualizar === 'SelecaoPlanoElegibilidadePage' && (
              <SelecaoPlanoElegibilidadePage
                oportunidade={oportunidade}
                controlaVisualizacao={this.controlaVisualizacao}
                finalizarSelecaoPlanoElegibilidade={this.finalizarSelecaoPlanoElegibilidade}
              />
            )}
            {visualizar === 'DistribuicaoFaixasElegibilidadePage' && (
              <DistribuicaoFaixasElegibilidadePage
                oportunidade={oportunidade}
                controlaVisualizacao={this.controlaVisualizacao}
                finalizarDistribuicaoFaixasElegibilidade={this.finalizarDistribuicaoFaixasElegibilidade}
              />
            )}
          </>
        )}
      </div>
    );
  }
}
